module.exports = __webpack_public_path__ + "static/media/shares-investment.8ac01f55.svg";